import React from "react";

import { chunk, groupBy } from "lodash";

import { type GetOverviewPerformance_me_overviewPage_performanceMetrics as OverviewPageMetric } from "@north-beam/nb-client-side";

import { MetricGroupBox } from "./metric-group-box";

export function MetricCharts({
  metricsOverview,
  isLoading,
}: {
  metricsOverview: OverviewPageMetric[];
  isLoading: boolean;
}) {
  const groupedMetrics = groupBy(metricsOverview, "groupName");
  const metricGroups = Object.entries(groupedMetrics).map(
    ([groupName, metrics]) => ({ groupName, metrics }),
  );

  const groupsOfFour = chunk(metricGroups, 4);
  if (groupsOfFour.length === 1) {
    return (
      <>
        {metricGroups.map(({ groupName, metrics }) => (
          <MetricGroupBox
            key={groupName}
            metrics={metrics}
            groupName={groupName}
            isLoading={isLoading}
          />
        ))}
      </>
    );
  }

  return (
    <>
      {groupsOfFour.map((vs) => (
        <div key={vs.map((v) => v.groupName).join("|")}>
          {vs.map(({ groupName, metrics }) => (
            <MetricGroupBox
              key={groupName}
              metrics={metrics}
              groupName={groupName}
              isLoading={isLoading}
            />
          ))}
        </div>
      ))}
    </>
  );
}
